import React, { useMemo, useState } from "react";

// Filtro por columna (estilo Excel), compartido entre Administración y
// Rutas: cada tabla de la app se filtra igual, columna a columna.
// `campos`: [ [clave, etiqueta, getter(row) => texto a comparar] ]
export function useFiltroColumnas(rows, campos) {
  const [filtros, setFiltros] = useState({});
  const setFiltro = (clave, valor) => setFiltros((prev) => ({ ...prev, [clave]: valor }));
  const limpiar = () => setFiltros({});
  const filtradas = useMemo(() => {
    const activos = Object.entries(filtros).filter(([, v]) => (v || "").trim());
    if (!activos.length) return rows;
    return rows.filter((r) =>
      activos.every(([clave, v]) => {
        const get = campos.find((c) => c[0] === clave)?.[2];
        const val = get ? get(r) : "";
        return String(val ?? "").toLowerCase().includes(v.trim().toLowerCase());
      })
    );
  }, [rows, filtros, campos]);
  return { filtros, setFiltro, limpiar, filtradas };
}

export function FilterHead({ campos, filtros, setFiltro, extra }) {
  return (
    <tr>
      {campos.map(([clave, etiqueta]) => (
        <th key={clave}>
          {etiqueta}
          <input placeholder="filtrar…" value={filtros[clave] || ""} onChange={(e) => setFiltro(clave, e.target.value)} />
        </th>
      ))}
      {extra}
    </tr>
  );
}

// Cabecera uniforme de cada panel con tabla filtrable: título, contador
// filtrado/total y "limpiar filtros".
export function PanelHead({ title, count, total, onLimpiar }) {
  return (
    <div className="card-headrow">
      <h3>{title}</h3>
      <div className="card-headrow-acc">
        <span className="muted">{count} de {total} registro(s)</span>
        <button className="btn" onClick={onLimpiar}>Limpiar filtros</button>
      </div>
    </div>
  );
}
